import VueRouter from "vue-router";
import NProgress from "nprogress";

import Entrada from './components/Entrada';
import QuemSomos from './components/QuemSomos';
import Servicos from './components/Servicos';
import Calendario from './components/Calendario';
import Novidades from './components/Novidades';
import Novidade from './components/Novidade';
import Contacto from './components/Contacto';
import Podcasts from './components/Podcasts';
import Podcast from './components/Podcast';

const routes = [
    {path: '/', component: Entrada, name: 'entrada'},
    {path: '/quem-somos', component: QuemSomos, name: 'quemSomos'},
    {path: '/servicos', component: Servicos, name: 'servicos'},
    {path: '/calendario/:year?/:month?/:day?', component: Calendario, name: 'calendario'},
    {path: '/novidades', component: Novidades, name: 'novidades'},
    {path: '/novidades/:id/:nome?', component: Novidade, name: 'novidade'},
    {path: '/contactos', component: Contacto, name: 'contacto'},
    {path: '/podcast', component: Podcasts, name: 'podcasts'},
    {path: '/podcast/:uuid/:author?/:title?', component: Podcast, name: 'podcast'},
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path !== from.path) {
        NProgress.start();
        NProgress.set(0.1);
    }
    next();
});

router.afterEach(() => {
    NProgress.done();
    //setTimeout(() => NProgress.done(), 500)
});

export default router;